module.exports = __webpack_public_path__ + "static/media/mobile-login.89cbb3b5.svg";